module.exports = __webpack_public_path__ + "img/dashboard.122785b2.svg";